import {useMemo} from "react";

import {useGetUserPreferencesQuery} from "../api/get_user_preferences";
import {IUserPreferences} from "../interfaces/IUserPreferences";

export const useUserPreferencesQueryParams = () => {
    const {data: userPreferencesFilters} = useGetUserPreferencesQuery();

    const getUserPreferencesQueryParams = (userPreferences: IUserPreferences | null | undefined) => {
        if (!userPreferences?.filters) {
            return {};
        }

        const {filters} = userPreferences;
        const queryParams: Record<string, string | number | string[]> = {};

        if (filters.type) {
            queryParams.type = parseInt(filters.type, 10);
        }
        if (filters.price_0) {
            queryParams.price_0 = parseInt(filters.price_0, 10);
        }
        if (filters.price_1) {
            queryParams.price_1 = parseInt(filters.price_1, 10);
        }
        if (filters.area_0) {
            queryParams.area_0 = parseInt(filters.area_0, 10);
        }
        if (filters.area_1) {
            queryParams.area_1 = parseInt(filters.area_1, 10);
        }
        if (filters.rooms_0) {
            queryParams.rooms_0 = parseInt(filters.rooms_0, 10);
        }
        if (filters.rooms_1) {
            queryParams.rooms_1 = parseInt(filters.rooms_1, 10);
        }
        if (filters.construction_end_date) {
            queryParams.construction_end_date = filters.construction_end_date;
        }
        if (filters.floor_choices && filters.floor_choices.length > 0) {
            queryParams.floor_choices = filters.floor_choices;
        }

        return queryParams;
    };

    return useMemo(() => {
        return getUserPreferencesQueryParams(userPreferencesFilters);
    }, [userPreferencesFilters]);
};
import {useMemo} from "react";

import {useGetUserPreferencesQuery} from "../api/get_user_preferences";
import {IUserPreferences} from "../interfaces/IUserPreferences";

export const useUserPreferencesQueryParams = () => {
    const {data: userPreferencesFilters} = useGetUserPreferencesQuery();

    const getUserPreferencesQueryParams = (userPreferences: IUserPreferences | null | undefined) => {
        if (!userPreferences?.filters) {
            return {};
        }

        const {filters} = userPreferences;
        const queryParams: Record<string, string | number | string[]> = {};

        if (filters.type) {
            queryParams.type = parseInt(filters.type, 10);
        }
        if (filters.price_0) {
            queryParams.price_0 = parseInt(filters.price_0, 10);
        }
        if (filters.price_1) {
            queryParams.price_1 = parseInt(filters.price_1, 10);
        }
        if (filters.area_0) {
            queryParams.area_0 = parseInt(filters.area_0, 10);
        }
        if (filters.area_1) {
            queryParams.area_1 = parseInt(filters.area_1, 10);
        }
        if (filters.rooms_0) {
            queryParams.rooms_0 = parseInt(filters.rooms_0, 10);
        }
        if (filters.rooms_1) {
            queryParams.rooms_1 = parseInt(filters.rooms_1, 10);
        }
        if (filters.construction_end_date) {
            queryParams.construction_end_date = filters.construction_end_date;
        }
        if (filters.floor_choices && filters.floor_choices.length > 0) {
            queryParams.floor_choices = filters.floor_choices;
        }

        return queryParams;
    };

    return useMemo(() => {
        return getUserPreferencesQueryParams(userPreferencesFilters);
    }, [userPreferencesFilters]);
};
